const COLORS=['#E06B3C','#3B82D0','#8D6AD2','#218C7A','#C94E81','#A97919','#5775B5','#A56036','#538426','#9671A7'];
export function fleetRouteColor(id){let hash=2166136261;for(const c of id)hash=Math.imul(hash^c.charCodeAt(0),16777619);return COLORS[(hash>>>0)%COLORS.length];}
